/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2554
 */

var r = require(/* 2555 */"./2555")
var i = require(/* 1172 */"./1172")
var o = require(/* 1173 */"./1173")
var a = o && o.isMap
var s = a ? i(a) : r
module.exports = s
